import SigamAPI from '~/utils/SigamAPI';

export default async function CreateMessage({
  message,
  chatId,
  institutionId,
}) {
  const response = await SigamAPI({
    url: `/SIGAM/${institutionId}/chat/${chatId}/message`,
    method: 'POST',
    data: {
      message,
    },
  });

  return response;
}
